const switchModalEquipServQuest = {
  label: 'Include comment option in question?',
  label2: 'Actions generated from this question make the equipment unfit for use ?',
  label3: 'Include file option in question?',
  labelWeight: 'Question weight',
  labelWeightError: 'The value must be greater than zero',
  labelDescriptiveImage: 'Descriptive image of the question',
};

export default switchModalEquipServQuest;
